import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import SolutionsPage from './pages/SolutionsPage';
import IndustriesPage from './pages/IndustriesPage';
import HowItWorksPage from './pages/HowItWorksPage';
import ResourcesPage from './pages/ResourcesPage';
import ContactPage from './pages/ContactPage';
import TrustCompliancePage from './pages/TrustCompliancePage';
// import BrandDashboardPage from './pages/BrandDashboardPage';
import CustomerRewardsPage from './pages/CustomerRewardsPage';
import QrDemoPage from './pages/QrDemoPage';
import ScrollToTop from './utils/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GlobalStyles />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/trust-compliance" element={<TrustCompliancePage />} />
          {/* <Route path="/brand-dashboard" element={<BrandDashboardPage />} /> */}
          <Route path="/rewards" element={<CustomerRewardsPage />} />
          <Route path="/demo" element={<QrDemoPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;